module.exports = __webpack_public_path__ + "ionicons.2c2ae068be3b089e0a5b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/ionicons/fonts/ionicons.eot?v=2.0.0
// module id = ../../../../../src/assets/fonts/ionicons/fonts/ionicons.eot?v=2.0.0
// module chunks = styles